// Generated by `yarn tokens:import --aos-ds` from the Figma component set "StatusStripe" (4157:8912). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const statusstripeContract = {
    component: 'StatusStripe',
    nodeId: '4157:8912',
    section: '[Web] Primitives',
    composes: [] as readonly ContractComposition[],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: [],
    props: {
        status: {
            kind: 'enum',
            values: ['critical', 'caution', 'neutral', 'success', 'info', 'warning'],
        },
    },
    variants: {
        'status=caution': {
            container: 'w-[0.25rem] h-[6.25rem]',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-status-caution w-[0.25rem] h-[6.25rem]',
            parts: {
                'status-bar': 'bg-status-caution w-[0.25rem] h-[6.25rem]',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [],
        },
        'status=critical': {
            container: 'w-[0.25rem] h-[6.25rem]',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-status-critical w-[0.25rem] h-[6.25rem]',
            parts: {
                'status-bar': 'bg-status-critical w-[0.25rem] h-[6.25rem]',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [],
        },
        'status=info': {
            container: 'w-[0.25rem] h-[6.25rem]',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-status-info w-[0.25rem] h-[6.25rem]',
            parts: {
                'status-bar': 'bg-status-info w-[0.25rem] h-[6.25rem]',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [],
        },
        'status=neutral': {
            container: 'w-[0.25rem] h-[6.25rem]',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-status-neutral w-[0.25rem] h-[6.25rem]',
            parts: {
                'status-bar': 'bg-status-neutral w-[0.25rem] h-[6.25rem]',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [],
        },
        'status=success': {
            container: 'w-[0.25rem] h-[6.25rem]',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-status-success w-[0.25rem] h-[6.25rem]',
            parts: {
                'status-bar': 'bg-status-success w-[0.25rem] h-[6.25rem]',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [],
        },
        'status=warning': {
            container: 'w-[0.25rem] h-[6.25rem]',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-status-warning w-[0.25rem] h-[6.25rem]',
            parts: {
                'status-bar': 'bg-status-warning w-[0.25rem] h-[6.25rem]',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
